import { render } from "./ServiceRegisterTable.vue?vue&type=template&id=3e8ba821"
import script from "./ServiceRegisterTable.vue?vue&type=script&lang=js"
export * from "./ServiceRegisterTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__